export enum CookieKeys {
  Language = 'language',
}

export enum Languages {
  Ru = 'ru',
  En = 'en',
}
